module.exports = __webpack_public_path__ + "img/yf4.00ff0a7d.jpg";